import { render } from "./Onboarding.vue?vue&type=template&id=25e0ce8c"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=25e0ce8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/Onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25e0ce8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25e0ce8c', __exports__)) {
    api.reload('25e0ce8c', __exports__)
  }
  
  module.hot.accept("./Onboarding.vue?vue&type=template&id=25e0ce8c", () => {
    api.rerender('25e0ce8c', render)
  })

}


export default __exports__